import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import {
  type CreateWorkerCredentialsRequest,
  createWorkerCredentialsRequestSchema,
  type CreateWorkerCredentialsResponse,
  createWorkerCredentialsResponseSchema,
} from "./schema";
import { WORKER_CREDENTIALS_ENDPOINT_URL } from "./useGetWorkerCredentials";

export function useCreateWorkerCredentials(
  options: UseMutationOptions<
    CreateWorkerCredentialsResponse,
    unknown,
    CreateWorkerCredentialsRequest
  > = {}
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body) => {
      const response = await post({
        url: WORKER_CREDENTIALS_ENDPOINT_URL,
        requestSchema: createWorkerCredentialsRequestSchema,
        responseSchema: createWorkerCredentialsResponseSchema,
        data: body,
      });
      return response.data;
    },
    onSuccess: (data, variables, context) => {
      // invalidate any cached worker credentials to ensure fresh fetch next time
      void queryClient.invalidateQueries({ queryKey: [WORKER_CREDENTIALS_ENDPOINT_URL] });
      void queryClient.invalidateQueries({
        queryKey: [
          `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${variables.data.attributes.workplaceId}/worker-credentials`,
        ],
      });
      options.onSuccess?.(data, variables, context);
    },
    ...options,
  });
}
